<div class="error-container">
    <div class="error-title">{{errorMsg['title']}}</div>
      <div class="error-code">{{errorMsg['status']}}</div>
      <div class="error-description">{{errorMsg['description']}}</div>
  </div>
  